/**
 * Country API client — autocomplete, banned check
 */
import apiClient from './client.js';

export const fetchCountries = () =>
  apiClient.get('/countries').then(r => r.data.countries);

export const searchCountries = (query) =>
  apiClient.get('/countries/search', { params: { q: query } }).then(r => r.data.countries);

export const fetchBannedCountries = () =>
  apiClient.get('/countries/banned').then(r => r.data.countries);
